// @copyright  2006-2026 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'practiceManagement.compliance.title': 'Compliance',
    'practiceManagement.compliance.notYetComputed': 'Not yet checked',
    'practiceManagement.compliance.notYetComputedHelp': 'We have not looked at this client yet. Refresh to check now.',
    // The same finding, told on the BOARD, where there is no Refresh to press
    // (2026-08-14: the row became a destination). The first sentence is
    // deliberately identical — it is the finding, and it is what the E2E reads —
    // and only the remedy differs, because only the remedy moved.
    'practiceManagement.compliance.notYetComputedBoardHelp': 'We have not looked at this client yet. Open them to check now.',
    'practiceManagement.compliance.nothingOutstanding': 'Nothing outstanding',
    'practiceManagement.compliance.updatedAgo': 'Updated {age} ago',
    'practiceManagement.compliance.stale': 'This may be out of date.',
    'practiceManagement.compliance.refresh': 'Refresh',
    'practiceManagement.compliance.refreshing': 'Checking…',
    'practiceManagement.compliance.refreshDenied': "You do not have access to this client's organisation. Ask a colleague who does to refresh it.",
    'practiceManagement.compliance.refreshFailed': 'We could not check this client. Try again.',
    'practiceManagement.compliance.returnsLabel': 'Returns',
    'practiceManagement.compliance.returnsOverdue': '{count} overdue',
    'practiceManagement.compliance.bankUnreconciled': '{count} unreconciled (oldest {date})',
    'practiceManagement.compliance.tasksOverdue': '{count} overdue',
    'practiceManagement.compliance.booksClosedTo': 'Books closed to {date}',
    'practiceManagement.compliance.booksNeverClosed': 'Books never closed',

    'practiceManagement.compliance.loading': 'Loading the compliance board…',
    'practiceManagement.compliance.error': 'We could not load the compliance board. Try again.',
    'practiceManagement.compliance.denied': 'You do not have access to the compliance board.',
    'practiceManagement.compliance.retry': 'Try again',
    'practiceManagement.compliance.empty': 'No clients to check yet. Set up a client from the clients screen and they will appear here.',
    'practiceManagement.compliance.goToClients': 'Go to clients',
    'practiceManagement.compliance.filterLabel': 'Outstanding in',
    'practiceManagement.compliance.filterAll': 'Anything',
    'practiceManagement.compliance.filterReturns': 'Returns',
    'practiceManagement.compliance.filterBanking': 'Banking',
    'practiceManagement.compliance.filterTasks': 'Tasks',
    'practiceManagement.compliance.bankingLabel': 'Bank',
    'practiceManagement.compliance.tasksLabel': 'Tasks',
    'practiceManagement.compliance.returnsDue': '{count} due',
    'practiceManagement.compliance.bankNoneUnreconciled': 'Nothing unreconciled',
    'practiceManagement.compliance.returnsNoneOverdue': 'Nothing overdue',
    'practiceManagement.compliance.tasksNoneOverdue': 'Nothing overdue',
    'practiceManagement.compliance.overdueMarker': 'Overdue',
    'practiceManagement.compliance.unnamedClient': 'Client not yet identified',
    'practiceManagement.compliance.openOrganisation': 'Open their organisation',
    'practiceManagement.compliance.clientDenied': "You do not have access to this client's compliance position.",
    'practiceManagement.compliance.clientError': "We could not load this client's compliance position. Try again.",
    'practiceManagement.compliance.filingsHeading': 'Filings',
    'practiceManagement.compliance.filingColumn.filing': 'Filing',
    'practiceManagement.compliance.filingColumn.period': 'Period',
    'practiceManagement.compliance.filingColumn.due': 'Due',
    'practiceManagement.compliance.filingColumn.lastFiled': 'Last filed',
    'practiceManagement.compliance.filingColumn.status': 'Status',
    'practiceManagement.compliance.filingStatus.due': 'Due',
    'practiceManagement.compliance.filingStatus.overdue': 'Overdue',
    'practiceManagement.compliance.filingStatus.filed': 'Filed',
    'practiceManagement.compliance.noFilings': 'No filing obligations were found for this client.',
    'practiceManagement.compliance.noDeadline': 'No set deadline',
    'practiceManagement.compliance.neverFiled': 'Never filed',

    'practiceManagement.compliance.refreshedJustNow': 'Updated a moment ago',
    'practiceManagement.compliance.ageMinutes': '{count} minutes',
    'practiceManagement.compliance.ageHours': '{count} hours',
    'practiceManagement.compliance.ageDays': '{count} days',
    'practiceManagement.compliance.ageOneHour': 'an hour',
    'practiceManagement.compliance.ageOneDay': 'a day',
};
